import { compose, isEmpty, pipe, without } from 'ramda'
import { connect } from 'react-redux'
import { loadResources } from '../store/modules/lazyResources'
import { componentDidMount } from './Lifecycles'

const mapStateToProps = (state, { reducers = [], epics = [] }) => ({
  areResourcesLoaded:
    isEmpty(without(state.lazyResources.reducers, reducers))
    && isEmpty(without(state.lazyResources.epics, epics))
  ,
})

const mapDispatchToProps = dispatch => ({
  loadResources: compose(dispatch, loadResources),
})

// didMount :: Props -> State
const didMount = ({ reducers, epics, loadResources }) => loadResources(reducers, epics)

const View = ({
  children,
  areResourcesLoaded,
}) => areResourcesLoaded ? <>{ children }</> : null

// lifecycles :: React.Component -> React.Component
const lifecycles = pipe(componentDidMount(didMount))(View)

const ResourceLoader = connect(
  mapStateToProps,
  mapDispatchToProps,
)(lifecycles)

export default ResourceLoader
